'use strict';

export default [
    () => {
        let loadingProcess = false;

        function startLoading() {
            loadingProcess = true;
        }

        function stopLoading() {
            loadingProcess = false;
        }

        function isLoading() {
           return loadingProcess;
        }

        return {
            startLoading,
            stopLoading,
            loadingProcess,
            isLoading,
        };
    },
];
